export default "__VITE_ASSET__CA4d2smV__"